import type { StreetOrientationPreference } from "building-types/building/streetOrientationTypesEnum";
import type { GeneratedDoorPlacement } from "building-types/doors/doorTypes";
import type { OpeningNoExprDescriptor } from "building-types/openings/opening";
import type { OpeningFuncOptions, OpeningPlacementOptions } from "building-types/openings/openingFuncOptions";
import type { RoomFilter, OpeningPlacementFilter } from "building-types/openings/openingTypesEnum";
import type { RoomType } from "building-types/rooms/roomTypesEnum";
import type { GeneratedWindowPlacement } from "building-types/windows/windowTypes";

export type OpeningPlacement = ManualOpeningPlacement | RoomTypeOpeningPlacement;

export type OpeningPlacementDescriptorTable = { [id: number]: OpeningNoExprDescriptor };

export type RoomTypeOpeningPlacementTable = {
  [startRoomType: string]: {
    [endRoomType: string]: {
      [key in StreetOrientationPreference]?: RoomTypeOpeningPlacement;
    };
  };
};

export type OpeningPlacementReturnValue = Partial<{
  readonly doorPlacements: GeneratedDoorPlacement[];
  readonly windowPlacements: GeneratedWindowPlacement[];
}>;

export interface RoomTypeOpeningPlacement {
  readonly type: "ROOM_TYPE";
  readonly options: OpeningFuncOptions;
  readonly roomStartTypes?: RoomType[];
  readonly roomStartFilter?: RoomFilter;
  readonly roomEndTypes?: RoomType[];
  readonly roomEndFilter?: RoomFilter;
  readonly precedence?: number;
  readonly streetOrientations?: StreetOrientationPreference[];
  readonly filter?: OpeningPlacementFilter;
}

export function roomTypeOpeningPlacementNew({
  options,
  roomStartTypes,
  roomStartFilter,
  roomEndTypes,
  roomEndFilter,
  precedence,
  streetOrientations,
  filter,
}: OpeningPlacementOptions): RoomTypeOpeningPlacement {
  return {
    type: "ROOM_TYPE",
    options,
    roomStartTypes,
    roomStartFilter,
    roomEndTypes,
    roomEndFilter,
    precedence,
    streetOrientations,
    filter,
  };
}

export function manualOpeningPlacementNew(
  blockId: string,
  locationId: string,
  edgeId: string,
  openings: OpeningPlacementDescriptorTable,
  exclusive: boolean = false,
  oppositeBlockId?: string,
  oppositeLocationId?: string,
  oppositeEdgeId?: string,
  precedence?: number,
): ManualOpeningPlacement {
  return {
    type: "MANUAL",
    blockId,
    locationId,
    edgeId,
    exclusive,
    oppositeBlockId,
    oppositeLocationId,
    oppositeEdgeId,
    precedence,
    openings,
  };
}

export interface ManualOpeningPlacement {
  readonly type: "MANUAL";
  readonly blockId: string;
  readonly locationId: string;
  readonly edgeId: string;
  readonly exclusive: boolean;
  readonly oppositeBlockId?: string;
  readonly oppositeLocationId?: string;
  readonly oppositeEdgeId?: string;
  readonly precedence?: number;
  readonly openings?: OpeningPlacementDescriptorTable;
}
